<script setup>
// This starter template is using Vue 3 <script setup> SFCs
// Check out https://v3.vuejs.org/api/sfc-script-setup.html#sfc-script-setup
// import Login from "@/components/login/index.vue";
</script>

<template>
  <!-- <HelloWorld msg="Hello Vue 3 + Vite" /> -->
  <!-- <login /> -->
  <a-config-provider
    :theme="{
      token: {
        colorPrimary: '#ff5a00',
      },
    }"
  >
    <router-view v-slot="{ Component, route }">
      <keep-alive>
        <component :is="Component" :key="route.meta.usePathKey ? route.path : undefined" />
      </keep-alive>
    </router-view>
  </a-config-provider>
</template>

<style>
html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Helvetica Neue",
    "PingFang SC",
    "Microsoft YaHei",
    "Source Han Sans SC",
    "Noto Sans CJK SC",
    "WenQuanYi Micro Hei",
    sans-serif;
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* text-align: center; */
  color: #2c3e50;
  width: 100%;
  height: 100%;
  font-size: 14px;
}

* {
  box-sizing: border-box;
}
</style>
